import React from 'react';

import BottomSheet from 'components/BottomSheet';
import ModalHeader from 'components/ModalHeader';

import { Container, Text, Close } from './styles';

interface Props {
  show: boolean;
  title: string;
  content?: string;
  close: string;
  children?: JSX.Element;
  onClose: () => void;
  onConfirm?: () => void;
  highlight?: boolean;
}

export const AlertBottomSheet = ({
  show,
  title,
  content,
  close,
  onClose,
  children,
  onConfirm,
  highlight = false,
}: Props) => (
  <BottomSheet modal noHeader show={show} onClose={onClose}>
    <Container>
      {title && <ModalHeader title={title} onClose={onClose} highlight={highlight} />}
      {children || <Text>{content}</Text>}
      <Close
        value={close}
        onClick={
          onConfirm
            ? () => {
                onConfirm();
                onClose();
              }
            : onClose
        }
      />
    </Container>
  </BottomSheet>
);

export default AlertBottomSheet;
